import { apiCall } from 'services/api';
import { getLoaders } from 'entities/_config';

import { AppStatus } from './types';
import { getFingerprint } from 'utils/fingerprint';
import { AnyObject } from 'types';

export const infraLoaders = getLoaders({
  appStatus: {
    load: async ({ version }: { version: string }): Promise<AppStatus> => {
      return apiCall({
        path: '/infra/web/status',
        method: 'get',
        auth: false,
        payload: {
          version,
        },
      });
    },
  },

  fingerprint: {
    load: async () => {
      const key = '________zzzzzzzzz_______';

      const saved = JSON.parse(localStorage.getItem(key)!);

      const generated = await getFingerprint();

      if (!saved) localStorage.setItem(key, JSON.stringify(generated));

      if (saved?.id !== generated.id) {
        console.log('DIVERGENT', {
          saved,
          generated,
        });
      }

      return {
        existing: saved,
        saved: saved.id ?? generated.id,
        generated,
      };
    },
  },

  syncFingerprint: {
    load: async (payload: AnyObject) => {
      const result = await apiCall({
        path: '/infra/web/register',
        payload,
      });

      return result;
    },
  },
});
